import { attach, createEffect, createStore, sample } from 'effector';
import type { ModuleManifest, TenantConfig } from '@buildex/module-contract';
import { $session, $tenant, $tenantConfig, buildModuleContext } from '@buildex/core';
import { MODULE_LOADERS } from './registry';
import { registerModuleLocales } from '../i18n';

/**
 * Поток старта кабинета (§5):
 * конфиг тенанта → загрузка ТОЛЬКО активных манифестов → onInit каждого модуля.
 */

export const loadModulesFx = createEffect<TenantConfig, ModuleManifest[], Error>((config) => {
  const loaders = config.modules
    .map((id) => MODULE_LOADERS[id])
    .filter((loader): loader is () => Promise<ModuleManifest> => loader !== undefined);
  return Promise.all(loaders.map((load) => load()));
});

const initModulesFx = attach({
  source: { session: $session, tenant: $tenant },
  effect: async ({ session, tenant }, manifests: ModuleManifest[]) => {
    for (const manifest of manifests) {
      registerModuleLocales(manifest);
      if (tenant !== null) {
        await manifest.onInit?.(buildModuleContext(session, tenant));
      }
    }
    return manifests;
  },
});

/** null — модули ещё не загружены */
export const $manifests = createStore<ModuleManifest[] | null>(null).on(
  initModulesFx.doneData,
  (_, manifests) => manifests,
);

sample({
  clock: $tenantConfig.updates,
  filter: (config): config is TenantConfig => config !== null,
  target: loadModulesFx,
});

sample({ clock: loadModulesFx.doneData, target: initModulesFx });
